<template>
    <pm-custom-dialog v-if="visible" v-model="visible" style="z-index: 999999999999;">
        <span v-if="!reason" slot="close-btn"></span>
        <div style="padding: 0 30px; text-align: center;">

            <div style="background: url(/images/onboarding/faq.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 20px 0px 20px 0; width: 100%; height: 170px;"></div>

            <div style="margin-bottom: 16px; text-align: center;">
                <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                <template v-if="trialDaysLeft > 1">
                    You still have <b>{{ trialDaysLeft }} days</b>
                </template>
                <template v-else>
                    You only have <b>{{ trialHoursLeft }} hours</b>
                </template>
                <br/>from the free period
                </h2>
            </div>

            <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 16px 30px;">
                DentiCalc includes photos, videos, calculator and SMART, try them all.
            </p>

            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="tryNow">
                I'LL TRY <span style="text-transform: none; font-weight: 600;">&nbsp;DentiCalc&nbsp;</span> NOW!
            </a>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="report">
                I NEED SUPPORT
            </a>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="close">
                CLOSE
            </a>
        </div>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import { trialDaysLeft, trialHoursLeft } from "@/utils/iap/trial-days";
import { isDev } from "@/utils/debug/is-dev";
export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
        trialDaysLeft: trialDaysLeft(),
        trialHoursLeft: trialHoursLeft(),
    }),
    methods: {
        tryNow() {
            window.Tracker.logEvent({
                event_name: "try_now",
                event_category: "iap",
                event_label: "cancel_dialog_trial",
            });
            this.close();
        },
        show() {
            this.visible = true;
            if (!isDev && this.trialDaysLeft == 0) {
                this.close();
            }
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
        report() {
            app.$bus.$emit('openAppDialog','storeSupport');
            window.Tracker.logEvent({
                event_name: "support",
                event_category: "iap",
                event_label: "cancel_dialog_trial",
            });
        },
    }
}
</script>
